import { Link } from 'react-router-dom';
import CtaBand from '../components/CtaBand';
import Icon from '../components/Icon';
import Layout, { PageHero } from '../components/Layout';
import { PROMISES } from '../constants/content';
import { ADDRESS, COMPANY_NAME, SITE_DOMAIN, SITE_NAME } from '../constants/site';

const VALUES = [
  {
    title: 'Patience first',
    text: 'Many of the people we help are retired researchers, not computer experts. We slow down, explain, and never rush.',
  },
  {
    title: 'Your data is sacred',
    text: 'A family tree can represent thirty years of work. We confirm a backup exists before we change anything.',
  },
  {
    title: 'Honest about cost',
    text: 'Guides are free and so is the first conversation. If a paid session would help, we say so and quote the price first.',
  },
  {
    title: 'Teach, don’t just fix',
    text: 'We explain what went wrong so you can recognise it — and often prevent it — next time.',
  },
];

export default function AboutPage() {
  return (
    <Layout>
      <PageHero
        eyebrow="About us"
        title="Real people who care about family history"
        lead={`${SITE_NAME} is an independent support service helping genealogists keep Family Tree Maker running smoothly.`}
        crumbs={[{ label: 'About Us' }]}
      />

      <section className="section">
        <div className="container split">
          <div className="split__copy">
            <p className="eyebrow">Our story</p>
            <h2>Built for the people behind the trees</h2>
            <p>
              We started {SITE_DOMAIN} after seeing the same thing again and again: dedicated family
              historians losing evenings — sometimes weeks — to installer errors, stuck syncs, and photos
              that suddenly showed broken links. The research was the hard part; the software should not be.
            </p>
            <p>
              Today our technicians help Windows and Mac users with every edition from Family Tree Maker
              2014 through 2024. We handle installs, activation, FamilySync, TreeVault, media relinking,
              printing, and moving to new computers.
            </p>
            <p>
              {SITE_NAME} is operated by <strong>{COMPANY_NAME}</strong>, {ADDRESS}. We are an independent
              company and are not affiliated with Software MacKiev, Ancestry, or FamilySearch.
            </p>
          </div>
          <div className="split__media">
            <img src="/images/community.webp" alt="Family members looking at photos together" width="640" height="480" loading="lazy" />
          </div>
        </div>
      </section>

      <section className="section section--parchment">
        <div className="container">
          <div className="section-head">
            <p className="eyebrow">What we believe</p>
            <h2>The values behind every session</h2>
          </div>
          <div className="card-grid card-grid--4">
            {VALUES.map((v) => (
              <article key={v.title} className="service-card">
                <span className="service-card__icon">
                  <Icon name="leaf" size={24} />
                </span>
                <h3>{v.title}</h3>
                <p>{v.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="section-head">
            <p className="eyebrow">Our commitments</p>
            <h2>What you can always expect</h2>
          </div>
          <ul className="promise-row">
            {PROMISES.map((p) => (
              <li key={p.title}>
                <Icon name="shield" size={26} />
                <div>
                  <strong>{p.title}</strong>
                  <span>{p.text}</span>
                </div>
              </li>
            ))}
          </ul>
          <p className="center">
            <Link to="/support-services" className="btn btn--outline">
              Explore our services
            </Link>
          </p>
        </div>
      </section>

      <CtaBand />
    </Layout>
  );
}
